import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
  addAllForTempExport,
  addAllMediaIDsFromClusterPageToTemp,
  clearSelectedMedia,
  setLastSelectedIndex,
  setTemporaryExportData,
  updateTemporaryExportData,
} from "../redux/SingleDataset/actions";
import useAllQueryParamsFilters from "./useAllQueryParamsFilters";
import {
  getAllSelectedFilters,
  getFilteredSimilarityClusters,
  getTemporaryExportDataArray,
} from "../redux/SingleDataset/selectors";

export function useExportSelection() {
  const dispatch = useDispatch();
  const exportData = useSelector(getTemporaryExportDataArray);
  const { datasetId, clusterId } = useParams();
  const clusters = useSelector(getFilteredSimilarityClusters);

  const selectedClusterOnDataPage =
    clusterId && exportData.length > 0
      ? exportData.find(
          (singleData) =>
            singleData.cluster_id === clusterId &&
            singleData.exportType === "cluster",
        )
      : null;

  const queryParamsFilters = useAllQueryParamsFilters();

  const allSelectedFilters = useSelector((state) =>
    getAllSelectedFilters(state, queryParamsFilters),
  );

  const handleSelectAll = () => {
    if (clusterId) {
      if (selectedClusterOnDataPage) {
        dispatch(
          updateTemporaryExportData(
            {
              ...selectedClusterOnDataPage,
              cluster_filters: allSelectedFilters,
            },
            "cluster",
          ) as any,
        );
      }
      dispatch(clearSelectedMedia() as any);
      dispatch(
        addAllMediaIDsFromClusterPageToTemp(
          datasetId!,
          allSelectedFilters,
        ) as any,
      );
    } else if (datasetId) {
      dispatch(addAllForTempExport(clusters, allSelectedFilters) as any);
    }
  };

  const handleClearAll = () => {
    if (clusterId) {
      if (selectedClusterOnDataPage) {
        dispatch(
          updateTemporaryExportData(
            { ...selectedClusterOnDataPage, cluster_filters: {} },
            "cluster",
          ) as any,
        );
      } else {
        dispatch(clearSelectedMedia() as any);
      }
    } else if (datasetId) {
      dispatch(setTemporaryExportData(null));
    }
    dispatch(setLastSelectedIndex(null));
  };

  // New function for MultiSelect's onChange
  const handleMultiSelectChange = async (
    selectedValues: string[],
    onOptionSelect: (selectedValues: string[]) => void | Promise<void>,
  ) => {
    await onOptionSelect(selectedValues);
    handleClearAll();
  };

  return { handleSelectAll, handleClearAll, handleMultiSelectChange };
}
